const ProgressBar = {
    init() {
        this.bar = document.querySelector('.header-progress__bar');
        this.container = document.querySelector('.header-progress');
        this.header = document.querySelector('.header-new, .header');

        if (!this.bar || !this.container || !this.header) {
            return;
        }

        this.ticking = false;
        this.bindEvents();
        this.updateWidth();
        this.updatePosition();
    },

    bindEvents() {
        const onScroll = () => {
            if (!this.ticking) {
                window.requestAnimationFrame(() => {
                    this.updateWidth();
                    this.updatePosition();
                });
                this.ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
    },

    updateWidth() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const docHeight = document.documentElement.scrollHeight || 0;
        const winHeight = window.innerHeight || 1;
        const max = Math.max(docHeight - winHeight, 1);
        const progress = Math.min(Math.max(scrollTop / max, 0), 1) * 100;
        this.bar.style.width = progress + '%';
        this.ticking = false;
    },

    updatePosition() {
        const rect = this.header.getBoundingClientRect();
        const top = Math.max(rect.top, 0);
        this.container.style.top = top + 'px';
    }
};

export default ProgressBar;